import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCurrentMatches, getUpcomingMatches } from '../services/cricketAPI';
import { useAuth } from '../context/AuthContext';
import Matches from './Matches';


const Home = () => {
  const [liveMatches, setLiveMatches] = useState([]);
  const [upcomingMatches, setUpcomingMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  // Mock user stats
  const userStats = {
    totalPredictions: 28,
    correctPredictions: 17,
    accuracy: '60.7%',
    rank: 432,
    balance: '₹1,250'
  };

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const [currentMatches, upcoming] = await Promise.all([
          getCurrentMatches(),
          getUpcomingMatches()
        ]);
        
        setLiveMatches(currentMatches);
        setUpcomingMatches(upcoming);
      } catch (error) {
        console.error('Error fetching matches:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, []);

  return (
    <div>
      {/* Hero Section - Redesigned */}
      <section className="relative rounded-2xl p-8 mb-10 overflow-hidden bg-gradient-to-r from-blue-600 to-indigo-800 text-white">
        <div className="absolute inset-0 opacity-20">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
            <defs>
              <pattern id="pattern-circles" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
                <circle cx="25" cy="25" r="8" fill="white" opacity="0.3" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#pattern-circles)" />
          </svg>
        </div>
        
        <div className="relative z-10 max-w-3xl">
          <h1 className="text-4xl font-bold mb-4">Predict Cricket Matches, Win Big Rewards</h1>
          <p className="text-xl mb-8 opacity-90">
            Join thousands of cricket fans in predicting match outcomes and earning real rewards.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link 
              to="/matches" 
              className="bg-white text-blue-700 px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition shadow-lg"
            >
              Start Predicting
            </Link>
            {!currentUser ? (
              <Link 
                to="/register" 
                className="bg-blue-500 bg-opacity-30 text-white border border-white border-opacity-40 px-6 py-3 rounded-lg font-medium hover:bg-opacity-40 transition"
              >
                Create Account
              </Link>
            ) : (
              <Link 
                to="/prediction-rules" 
                className="bg-blue-500 bg-opacity-30 text-white border border-white border-opacity-40 px-6 py-3 rounded-lg font-medium hover:bg-opacity-40 transition"
              >
                Prediction Rules
              </Link>
            )}
          </div>
        </div>
      </section>

      {/* Referral Banner */}
      <section className="relative rounded-xl p-5 mb-8 overflow-hidden bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg">
        <div className="absolute top-0 right-0 opacity-20">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-24 h-24">
            <path d="M21.721 12.752a9.711 9.711 0 00-.945-5.003 12.754 12.754 0 01-4.339 2.708 18.991 18.991 0 01-.214 4.772 17.165 17.165 0 005.498-2.477zM14.634 15.55a17.324 17.324 0 00.332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 00.332 4.647 17.385 17.385 0 005.268 0zM9.772 17.119a18.963 18.963 0 004.456 0A17.182 17.182 0 0112 21.724a17.18 17.18 0 01-2.228-4.605zM7.777 15.23a18.87 18.87 0 01-.214-4.774 12.753 12.753 0 01-4.34-2.708 9.711 9.711 0 00-.944 5.004 17.165 17.165 0 005.498 2.477zM21.356 14.752a9.765 9.765 0 01-7.478 6.817 18.64 18.64 0 001.988-4.718 18.627 18.627 0 005.49-2.098zM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 001.988 4.718 9.765 9.765 0 01-7.478-6.816zM13.878 2.43a9.755 9.755 0 016.116 3.986 11.267 11.267 0 01-3.746 2.504 18.63 18.63 0 00-2.37-6.49zM12 2.276a17.152 17.152 0 012.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0112 2.276zM10.122 2.43a18.629 18.629 0 00-2.37 6.49 11.266 11.266 0 01-3.746-2.504 9.754 9.754 0 016.116-3.985z" />
          </svg>
        </div>
        <div className="flex items-center justify-between">
          <div className="max-w-2xl">
            <h2 className="text-2xl font-bold mb-2">Invite Friends, Get 1000 Coins Bonus!</h2>
            <p className="text-white text-opacity-90 mb-3">
              Refer a friend and get 1000 coins in your wallet when they sign up. After every 5 referrals, get 1000 coins extra bonus!
            </p>
            <Link 
              to="/referrals" 
              className="inline-flex items-center bg-white text-orange-500 px-5 py-2 rounded-lg font-medium hover:bg-opacity-90 transition shadow-md"
            >
              <span>Get Your Referral Link</span>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </Link>
          </div>
          <div className="hidden md:block">
            <div className="bg-white bg-opacity-20 p-3 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-16 h-16">
                <path fillRule="evenodd" d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z" clipRule="evenodd" />
                <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
              </svg>
            </div>
          </div>
        </div>
      </section>
      
    <Matches/>

    </div>
  );
};

export default Home; 